module.exports = __webpack_public_path__ + "static/img/shanghai1.45d4eca.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/homePortal/shanghai1.jpg
// module id = rdcC
// module chunks = 1